import BeautyPreferenceSpoke from 'components/BeautyPreferenceSpoke/BeautyPreferenceSpoke';
import { withBeautyPreferenceSpokeProps } from 'viewModel/beautyPreferenceSpoke/withBeautyPreferenceSpokeProps';

export default withBeautyPreferenceSpokeProps(BeautyPreferenceSpoke);
